import { Percentage } from '@sparkdotfi/common-universal'

import { formatPercentage } from '@/domain/common/format'
import { MarketSparkRewards } from '@/features/spark-rewards/types'
import { MobileViewOptions } from '@/ui/molecules/data-table/types'
import { SparkRewardPill } from '@/ui/molecules/spark-reward-pill/SparkRewardPill'

interface ApyWithRewardsCellProps {
  baseApy: Percentage | undefined
  sparkRewards?: MarketSparkRewards[]
  mobileViewOptions?: MobileViewOptions
  apyDataTestId?: string
}

export function ApyWithRewardsCell({ mobileViewOptions, ...rest }: ApyWithRewardsCellProps) {
  if (mobileViewOptions?.isMobileView) {
    return (
      <div className="flex flex-row items-center justify-between">
        <div className="typography-label-4 text-secondary">{mobileViewOptions.rowTitle}</div>
        <CellContent {...rest} />
      </div>
    )
  }

  return <CellContent {...rest} />
}

function CellContent({ baseApy, sparkRewards, apyDataTestId }: Omit<ApyWithRewardsCellProps, 'mobileViewOptions'>) {
  return (
    <div className="flex flex-col items-end gap-2">
      <div className="flex items-center justify-end gap-1 lg:gap-1.5">
        <div className="typography-label-2 text-primary" data-testid={apyDataTestId}>
          {formatPercentage(baseApy)}
        </div>
      </div>
      {sparkRewards && (
        <div className="flex flex-wrap justify-end gap-1">
          {sparkRewards.map((sparkReward, index) => (
            <SparkRewardPill key={index} {...sparkReward} />
          ))}
        </div>
      )}
    </div>
  )
}
